var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v("\n  © 2019 iRecharge Merchant Service\n")])}
var staticRenderFns = []

export { render, staticRenderFns }